module.exports = __webpack_public_path__ + "static/media/lumina_thumb_even.eb69ad93.jpg";